import { Tooltip } from "@mui/material";

const TruncatedText = ({ text, maxWidth = "100%" }) => {
	if (!text) return <span>{text}</span>;

	return (
		<Tooltip title={text} arrow>
			<span
				style={{
					overflow: "hidden",
					textOverflow: "ellipsis",
					whiteSpace: "nowrap",
					display: "inline-block",
					maxWidth,
					cursor: "pointer",
					padding: "0 4px",
				}}
			>
				{text}
			</span>
		</Tooltip>
	);
};

export default TruncatedText;
